export default function Session_reinitNavigationStructure() {
    gd.spaces?.projects?.updateEnabled()

    gd.spaces?.workspaces.initFromSession()
    gd.spaces?.removeNavigationStructure()
    gd.spaces?.initNavigationStructure()
}